<div class="flex flex-col font-archivo gap-1">
  <label *ngIf="label" [for]="id" class="block font-archivo font-normal leading-[29px] lg:text-[1.125rem] md:text-[1.125rem] sm:text-[1.125rem] text-[#444955] text-[1rem] text-gray-700 xs:text-[1.125rem]">{{label}} <span *ngIf="required" class="text-danger-500">*</span></label>
  <div class="relative">
    <!-- Loading Skeleton -->
    @if (isLoading) {
    <div @skeletonFadeIn class="absolute inset-0 flex items-center px-3 py-2  z-20 bg-transparent rounded border border-gray-300 shadow-sm">
      <div class="w-full h-6 bg-gray-200 rounded skeleton-shimmer relative"></div>
    </div>
    }

    <!-- Actual Textarea Field -->
    <textarea
      [id]="id"
      [rows]="rows"
      [cols]="cols"
      [value]="value"
      (input)="handleInput($any($event.target).value)"
      (blur)="handleBlur()"
      [maxLength]="maxLength"
      [placeholder]="placeholder"
      [disabled]="disabled || isLoading"
      autocomplete="new-password"
      [style.transition]="'opacity 200ms ease-out'"
      [style.background-color]="isLoading ? 'transparent' : null"
      class="shadow-sm block px-3 py-2 border border-[#d0d1d4] focus:ring-0 focus:border-gray-500 lg:text-[20px] md:text-[20px] sm:text-[20px] xs:text-[20px] text-[16px] rounded disabled:cursor-not-allowed focus:outline focus:outline-none focus:-outline-offset-1 focus:outline-none relative z-0"
      [ngClass]="{
        'outline outline-1 -outline-offset-1 outline-danger-500': hasError,
        'bg-gray-200 font-bold': disabled,
        'w-full': cols == 100
      }">
    </textarea>

    <span *ngIf="hasError" class="absolute -bottom-5 text-danger-500 text-sm">{{errorMessage}}</span>
  </div>
</div>